(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lib_azas_map", [], factory);
	else if(typeof exports === 'object')
		exports["lib_azas_map"] = factory();
	else
		root["lib_azas_map"] = factory();
})(window, function() {
return 